//initial redux
import { put, call, takeEvery, fork, all, take } from "redux-saga/effects";
import * as router from "react-router-redux";
import { TreeMap } from "../../utils";

class SelectIdentifier {
   constructor(_id, actions) {
      this.id = _id;
      this.map = actions;
   }
   rerenderthis = 0;
   id;
   map = new TreeMap();
   isOpen = false;
}

const initialState = {
   selects: {},
};

/////////
//types
export const types = {
   TOGGLE_MENU: "screens/menu/TOGGLE_MENU",
   TOGGLE_NODE: "screens/menu/TOGGLE_NODE",
   REGISTER_SELECT: "screens/menu/REGISTER_SELECT",

   PUT_ACTIONS: "screens/menu/PUT_ACTIONS",
};

///////////
//reducers
export const reducers = {
   reducer(state = initialState, action) {
      switch (action.type) {
         case types.TOGGLE_MENU: {
            let select = state.selects[action.payload.id];
            select.isOpen = !select.isOpen;
            return { ...state, selects: state.selects };
         }

         case types.TOGGLE_NODE: {
            let select = state.selects[action.payload.id];
            select.map[action.payload.node._tree.own].isOpen = !select.map[action.payload.node._tree.own].isOpen;
            select.rerenderthis++;
            return { ...state, selects: state.selects };
         }

         case types.PUT_ACTIONS: {
            let select = state.selects[action.payload.selectId];
            select.map = actions.payload.map;
            select.rerenderthis++;
            return { ...state, selects: state.selects };
         }

         case types.REGISTER_SELECT: {
            return {
               ...state,
               selects: {
                  ...state.selects,
                  [action.payload.id]: new SelectIdentifier(action.payload.id, action.payload.map)
               }
            };
         }

         default:
            return state;
      }
   }
};

//////////
//sagas
export const sagas = {
   *rootSaga() {
      yield all([]);
   }
};

////////
//actions
export const actions = {
   registerSelect(id, map) {
      return {
         type: types.REGISTER_SELECT,
         payload: {
            id,
            map
         }
      };
   },
   putActions(selectId, map) {
      return {
         type: types.PUT_ACTIONS,
         payload: {
            selectId, map
         }
      };
   },

   toggleMenu(id) {
      return {
         type: types.TOGGLE_MENU,
         payload: {
            id
         }
      };
   },
   toggleOpenNode(id, node, hide) {
      return {
         type: types.TOGGLE_NODE,
         payload: {
            id, node, hide
         }
      };
   },

   genericAction(type, data) {
      return {
         type,
         payload: data
      };
   }
};



// WEBPACK FOOTER //
// ./src/components/TreeSelect/redux.js